import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import { ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import App from '../App.vue'
import router from '../router'
import i18n from '../i18n'

// Log a clear message for uncaught network errors (apiFetch throws a descriptive Error; this catches any remaining "Failed to fetch")
window.addEventListener('unhandledrejection', (event) => {
  const r = event.reason
  if (r instanceof TypeError && r.message === 'Failed to fetch') {
    console.error('API request failed: Network error. Check your connection and that the server is running.')
  }
})

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary:  '#4a90b9', //'#3f51b5',
    secondary: '#3b82f6',
  },
}

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: '#90caf9',
    secondary: '#03dac6',
  },
}

// Theme will be loaded from user settings after login
// For initial load, use localStorage as fallback
const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: savedTheme === 'dark' ? 'dark' : 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
})

const app = createApp(App)
app.use(vuetify)
app.use(router)
app.use(i18n)
app.mount('#app')

